import { Image, Spin, Typography } from "antd";
import { SUPPORTED_IMG_FILES } from "Common/constant";
import { useEffect, useState } from "react";

const MultiMediaMessage = ({ message }) => {
  const fileName = message.media.filename;
  const lastDotIndex = fileName.lastIndexOf(".");
  const suffix = fileName.substring(lastDotIndex - 1);
  const text = fileName.slice(0, lastDotIndex - 1).trim();
  const isImage = SUPPORTED_IMG_FILES.includes(message.media.state.contentType);

  const [url, setURL] = useState(null);

  const handleDocDownload = () => {
    message.media
      .getContentTemporaryUrl()
      .then((url) => {
        window.open(url, "_blank");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    message.media
      .getContentTemporaryUrl()
      .then((url) => {
        setURL(url);
      })
      .catch((error) => {});
  }, []);
  return (
    <>
      {!url && !isImage && (
        <div className="doc_loader">
          <Spin />
        </div>
      )}
      {!url && isImage && (
        <div className="image_loader">
          <Spin />
        </div>
      )}
      {url && !isImage && (
        <div className="chat_doc_sec">
          <Typography.Text
            onClick={handleDocDownload}
            className="doc_file_name"
            ellipsis={{
              tooltip: fileName,
              suffix,
            }}
          >
            {text}
          </Typography.Text>
        </div>
      )}
      {url && isImage && <Image width={150} src={url} />}
    </>
  );
};
export default MultiMediaMessage;
